export enum FileIoDirection {
  Upload = 'Upload',
  Download = 'Download',
  Delete = 'Delete'
}
